import { render, staticRenderFns } from "./Layer.vue?vue&type=template&id=6edf587a"
import script from "./Layer.vue?vue&type=script&lang=js"
export * from "./Layer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports